var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bat",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.83 77.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2e5299d4-4224-4b21-8411-d616d7494bbc {\n        fill: #000;\n      }\n      @keyframes fly-up {\n        0%, 100% { fill: #000; }\n        50% { fill: transparent; }\n      }\n      @keyframes fly-down {\n        0%, 100% { fill: transparent; }\n        50% { fill: #000; }\n      }\n      .wings-up {\n        animation: fly-up .2s step-end infinite;\n      }\n      .wings-down {\n        animation: fly-down .2s step-end infinite;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "wings-up"
  }, /*#__PURE__*/React.createElement("path", {
    className: "wings-up",
    d: "M29.21,44.25l-3.99-21.44L18.77,0c-.07,2.73-1.51,5.18-3.25,6.27.51,6.43-2.85,11-7.63,14.28,2.05,6.68.09,17.53-5.82,22.11l27.15,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wings-up",
    d: "M30.4,48.49l-1.59-17.92-4.11-19.45c-.43,2.18-2.33,3.89-4.37,4.46-.28,5.25-4.54,8.33-10.21,10.11,1.38,5.73-2.17,14.09-9.24,16.72l29.52,6.08Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "wings-down"
  }, /*#__PURE__*/React.createElement("path", {
    className: "wings-down",
    d: "M30.99,41.96l-3.99,17.14-6.45,18.22c-.07-2.18-1.51-4.14-3.25-5.01.51-5.14-2.85-8.79-7.63-11.41,2.05-5.34.09-14.01-5.82-17.67l27.15-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wings-down",
    d: "M32.18,45.63l-7.41,15.66-10.3,16.32c.31-2.08-.92-4.16-2.67-5.25,1.47-4.8-1.56-8.78-6.33-12.01,3.19-4.76,2.59-13.29-3.24-17.67l29.96,2.94Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "bat-body",
    className: "bat-body",
    d: "M0,42.4l33.83,4.77v-5.27c0-.71-.6-1.71-1.31-1.67h-.17s-.8-.93-.8-.93l-.13,1.01L0,42.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat);
export default __webpack_public_path__ + "static/media/bat.66b0b8ac45b662fd0f73d0c179599513.svg";
export { ForwardRef as ReactComponent };